import { useMutation, useQuery } from "@tanstack/react-query"
import api from "~/api2"

import api2 from "~/api2"
import { queryKeys } from "~/constants/queryKeys"
import { useCampContext } from "~/contexts/CampProvider"
import { useNotification } from "~/contexts/NotificationProvider"
import { ICampUpdate } from "../camps"

export const useCamp = (campIdProp?: string) => {
  const { campId: contextCampId } = useCampContext()
  const { showNotification } = useNotification()

  const campId = contextCampId || campIdProp
  const fetchCamp = useQuery({
    queryKey: [queryKeys.CAMP, campId],
    queryFn: () => apiFetchCamp(campId),
    staleTime: 3000,
    gcTime: 30000,
    enabled: !!campId,
    placeholderData: (previousData) => previousData,
  })

  const updateCamp = useMutation<any, Error, ICampUpdate>({
    mutationFn: (data) => api.Camps.update(campId, data),
    onSuccess: () => {
      showNotification({
        type: "success",
        title: "Changes successfully saved!",
      })
    },
    onError: () => {
      showNotification({
        type: "error",
        title: "Changes not successfully saved!",
      })
    },
  })

  return {
    index: fetchCamp,
    update: updateCamp,
  }
}

const apiFetchCamp = async (campId: string) => {
  try {
    return await api2.Me.camp(campId)
  } catch (error) {
    console.error("Error fetching Camp:", error)
    throw error
  }
}
